import {Component, Inject, OnInit, TemplateRef, ViewChild, ViewContainerRef} from '@angular/core';
import {IoTreeNodeModel} from '../../modules/imaging/models/io-tree-node.model';
import {PresentationFoldersConfigurationModel} from '../../models/configuration/presentation-folders-configuration.model';
import {MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef} from '@angular/material/dialog';
import {FileManagerService} from '../../modules/file-manager/file-manager.service';
import {Globals} from '../../globals';
import {
  PresentationFoldersConfigurationService
} from '../../modules/configuration/ui/presentation-folders-configuration/presentation-folders-configuration.service';
import {DocumentFolderDataModel} from '../../models/document/document-folder-data.model';
import {IoTreeNodeTypeModel} from '../../modules/imaging/models/io-tree-node-type.model';
import {ITdoTreeItem} from '../../tdo-controls/common/tdo-tree/models/i-tdo-tree-item';
import {TemplatePortal} from '@angular/cdk/portal';
import {fromEvent, Subscription} from 'rxjs';
import {filter, take} from 'rxjs/operators';
import {Overlay, OverlayRef} from '@angular/cdk/overlay';
import {
  TdoOrganizerRenameDialogComponent
} from '../../main-interface/organizer/dialogs/tdo-organizer-rename.dialog/tdo-organizer-rename-dialog.component';
import {DocumentFolderTypeEnum} from '../../models/enum/document/document-folder-type.enum';
import { SignalrService } from 'src/app/services/socket/signalr.service';
@Component({
  selector: 'app-save-lib-lec-dialog',
  templateUrl: './save-lib-lec-dialog.component.html',
  styleUrls: ['./save-lib-lec-dialog.component.scss']
})
export class SaveLibLecDialogComponent implements OnInit {
  @ViewChild('lectureContextMenu') lectureContextTemplate: TemplateRef<any>;

FolderTreeData: IoTreeNodeModel[] = [];
selectedFolderTreeNode: IoTreeNodeModel;
libraryTreeData: IoTreeNodeModel[] = [];
lectureTreeData: IoTreeNodeModel[] = [];
selectedLibraryTreeNodes: IoTreeNodeModel[] = [];
selectedLectureTreeNodes: IoTreeNodeModel[] = [];
selectedLibLecTreeNodes: string[] = [];
tableName: string;
folderList: PresentationFoldersConfigurationModel[];
selectedFolder: PresentationFoldersConfigurationModel;
private overlayRef: OverlayRef | null;
private sub: Subscription;

constructor(@Inject(MAT_DIALOG_DATA) private data: any,
            public fileManagerService: FileManagerService,
            private dialog: MatDialog,
            private globals: Globals,
            private overlay: Overlay,
            private viewContainerRef: ViewContainerRef,
            private presentationService: PresentationFoldersConfigurationService,
            public dialogRef: MatDialogRef<SaveLibLecDialogComponent>,
            private signalrService: SignalrService) {
  if (data.FromTable !== 'undefined') {
    this.tableName = data.FromTable;
  } else {
    this.tableName = '';
  }
  console.log('mtm tablename ', this.tableName);
}

ngOnInit(): void {
  this.init();
}

private async init() {
  if (this.tableName === 'LibraryLecture')  {
    this.fileManagerService.getLibraryDocumentFolders().subscribe((res) => {
      this.initLibraryTree(res.LibraryFolders);
      this.initLectureTree(res.LectureFolders);
    });
  }
}
private initLibraryTree(folders: DocumentFolderDataModel[]): void {
  const treeNode = new IoTreeNodeModel();
  const rootNodeData = folders[0];
  treeNode.id = rootNodeData.DocumnetFolderId;
  treeNode.name = rootNodeData.FolderName;
  treeNode.type = IoTreeNodeTypeModel.Library;
  treeNode.isExpanded = true;
  this.libraryTreeData.push(treeNode);
  const nonRootFolders = folders.filter(p => p.DocumentFolderParentId !== null);

  for (const folder of nonRootFolders) {
  const childNode = new IoTreeNodeModel();
  childNode.id = folder.DocumnetFolderId;
  childNode.name = folder.FolderName;
  childNode.type = IoTreeNodeTypeModel.Library;
  childNode.isExpanded = nonRootFolders.some(p => p.DocumentFolderParentId === folder.DocumnetFolderId);

  if (folder.DocumentFolderParentId === treeNode.id) {
    treeNode.children.push(childNode);
  } else {
    const parent = this.sortFoldersIntoFolders(treeNode, folder);
    parent.children.push(childNode);
  }
}
}

private initLectureTree(folders: DocumentFolderDataModel[]): void {
  const treeNode = new IoTreeNodeModel();
  const rootNodeData = folders[0];
  treeNode.id = rootNodeData.DocumnetFolderId;
  treeNode.name = rootNodeData.FolderName;
  treeNode.type = IoTreeNodeTypeModel.Lecture;
  treeNode.isExpanded = true;
  this.lectureTreeData.push(treeNode);
  const nonRootFolders = folders.filter(p => p.DocumentFolderParentId !== null);

  for (const folder of nonRootFolders) {
  const childNode = new IoTreeNodeModel();
  childNode.id = folder.DocumnetFolderId;
  childNode.name = folder.FolderName;
  childNode.type = IoTreeNodeTypeModel.Lecture;
  if (nonRootFolders.find(p => p.DocumentFolderParentId === folder.DocumnetFolderId)) {
    childNode.isExpanded = true;
  } else {
    childNode.isExpanded = false;
  }

  if (folder.DocumentFolderParentId === treeNode.id) {
    treeNode.children.push(childNode);
  } else {
    const parent = this.sortFoldersIntoFolders(treeNode, folder);
    parent.children.push(childNode);
  }
}
}
sortFoldersIntoFolders(treeNode: IoTreeNodeModel, folder: DocumentFolderDataModel): IoTreeNodeModel {
  const node = treeNode.children.find(p => p.id === folder.DocumentFolderParentId);
  if (node) {
    return node;
  } else {
    for (const innerNode of treeNode.children) {
      const tmp = this.sortFoldersIntoFolders(innerNode, folder);
      if (tmp) {
        return tmp;
      }
    }
  }
}

onCancelClick() {
  this.dialogRef.close(null);
}

onOkClick() {
  if (this.selectedLibraryTreeNodes.length > 0) {
    for (const node of this.selectedLibraryTreeNodes) {
      this.selectedLibLecTreeNodes.push(node.id);
    }
  }
  if (this.selectedLectureTreeNodes.length > 0) {
    for (const node of this.selectedLectureTreeNodes) {
      this.selectedLibLecTreeNodes.push(node.id);
    }
  }
  console.log('mtm this.selectedLibraryTreeNode ', this.selectedLibraryTreeNodes);
  this.dialogRef.close(this.selectedLibLecTreeNodes);
}

isFolderPresentationItemSelected(item: ITdoTreeItem): boolean {
  return item === this.selectedFolderTreeNode;
}
isItemSelected(item: ITdoTreeItem): boolean {
  return this.selectedLibraryTreeNodes.indexOf(item as IoTreeNodeModel) >= 0;
}

isLectureItemSelected(item: ITdoTreeItem): boolean {
  return this.selectedLectureTreeNodes.indexOf(item as IoTreeNodeModel) >= 0;
}

onLibraryTreeItemSelected(item: ITdoTreeItem) {
  if (item.children.length === 0) {
    item.isExpanded = false;
  } else {
    item.isExpanded = !item.isExpanded;
  }
  const idx = this.selectedLibraryTreeNodes.indexOf(item as IoTreeNodeModel);
  if (idx >= 0) {
    this.selectedLibraryTreeNodes.splice(idx, 1);
    return;
  }
  this.selectedLibraryTreeNodes.push(item as IoTreeNodeModel);
}

onLibraryTreeContext(event: MouseEvent, item: any) {
  this.openContext(event, this.lectureContextTemplate, item);
}

onLectureTreeItemSelected(item: ITdoTreeItem) {
  if (item.children.length === 0) {
    item.isExpanded = false;
  } else {
    item.isExpanded = !item.isExpanded;
  }
  const idx = this.selectedLectureTreeNodes.indexOf(item as IoTreeNodeModel);
  if (idx >= 0) {
    this.selectedLectureTreeNodes.splice(idx, 1);
    return;
  }
  this.selectedLectureTreeNodes.push(item as IoTreeNodeModel);

}

private initFolderTree(folders: PresentationFoldersConfigurationModel[]): void {
  let isFound = false;
  let rootNode: IoTreeNodeModel;
const rootFolders = folders.filter(p => p.ParentFolderPresentationID == null);
const nonRootFolders = folders.filter(p => p.ParentFolderPresentationID !== null);
for (const root of rootFolders) {
  rootNode = new IoTreeNodeModel();
  const rootNodeData = root;
  rootNode.id = rootNodeData.FolderPresentationID;
  rootNode.name = rootNodeData.DisplayName;
  rootNode.type = IoTreeNodeTypeModel.Default;
  const hasChildFolders = nonRootFolders.some(p => p.ParentFolderPresentationID === rootNode.id);
  rootNode.isExpanded = hasChildFolders;
  this.FolderTreeData.push(rootNode);

  for (const folder of nonRootFolders) {
    const childNode = new IoTreeNodeModel();
    childNode.id = folder.FolderPresentationID;
    childNode.name = folder.DisplayName;
    childNode.type = IoTreeNodeTypeModel.Default;
    if (childNode.children.length === 0) {
      childNode.isExpanded = false;
    } else {
      childNode.isExpanded = true;
    }
    if (folder.ParentFolderPresentationID === rootNode.id) {
      rootNode.children.push(childNode);
      isFound = true;
    }
    else {
      const parent = this.sortFoldersIntoFoldersPresentation(rootNode, folder);
      if (parent) {
        parent.children.push(childNode);
      }
    }
  }
}
}

sortFoldersIntoFoldersPresentation(treeNode: IoTreeNodeModel, folder: PresentationFoldersConfigurationModel): IoTreeNodeModel {
  const node = treeNode.children.find(p => p.id === folder.ParentFolderPresentationID);
  if (node) {
    return node;
  } else {
    for (const innerNode of treeNode.children) {
      const tmp = this.sortFoldersIntoFoldersPresentation(innerNode, folder);
      if (tmp) {
        return tmp;
      }
    }
  }
}
onFolderTreeItemSelected(item: ITdoTreeItem) {
  if (item.children.length === 0) {
    item.isExpanded = false;
  } else {
    item.isExpanded = !item.isExpanded;
  }
  if (this.selectedFolderTreeNode === item) {
    return;
  }
  this.selectedFolderTreeNode = item as IoTreeNodeModel;
  const selected = this.folderList.filter(p => p.FolderPresentationID === this.selectedFolderTreeNode.id);
  this.selectedFolder = selected[0];
}

onFolderTreeContext($event: MouseEvent, item: any) {

}

addDocumentFolder(data: IoTreeNodeModel) {
  const config = new MatDialogConfig();
  config.panelClass = 'standard-dialog';
  config.data = {isNew: true};
  this.dialog.open(TdoOrganizerRenameDialogComponent, config).afterClosed().subscribe((res) => {
    if (res) {
      const mod = new DocumentFolderDataModel();
      mod.FolderName = res;
      mod.DocumentFolderParentId = data.id;
      switch (data.type) {
        case IoTreeNodeTypeModel.Library:
          mod.enumDocumnetFolderTypeID = DocumentFolderTypeEnum.Library;
          break;
        case IoTreeNodeTypeModel.Lecture:
          mod.enumDocumnetFolderTypeID = DocumentFolderTypeEnum.Lecture;
          break;
      }
      this.fileManagerService.addDocumentFolder(mod).subscribe((response) => {
        data.isExpanded = true;
        data.children.push(this.convertFolderModelToTreeModel(response));
        this.signalrService.messageAllUsers(SignalrService.REFRESH_FOLDERS, { patientId: this.globals.currentPatientId });
      });
    }
  });
}

  convertFolderModelToTreeModel(folder: DocumentFolderDataModel): IoTreeNodeModel {
    const treeNode = new IoTreeNodeModel();
    treeNode.id = folder.DocumnetFolderId;
    treeNode.name = folder.FolderName;

    switch (folder.enumDocumnetFolderTypeID.toUpperCase()) {
      case DocumentFolderTypeEnum.Library:
        treeNode.type = IoTreeNodeTypeModel.Library;
        break;
      case DocumentFolderTypeEnum.Lecture:
        treeNode.type = IoTreeNodeTypeModel.Lecture;
        break;
    }

    return treeNode;
  }

  isTrashFolder(data: any) {
    return false;
  }
  // Context boilerplate
  openContext({x, y}: MouseEvent, template: TemplateRef<any>, data: any, data1: any = null, closeOnItemClick = true): void {
    this.closeContext();
    x = x + 100;
    y = y - 10;
    const positionStrategy = this.overlay.position().flexibleConnectedTo({x, y}).withPositions([
      {
        originX: 'end',
        originY: 'bottom',
        overlayX: 'end',
        overlayY: 'top'
      }
    ]);

    this.overlayRef = this.overlay.create({
      positionStrategy,
      scrollStrategy: this.overlay.scrollStrategies.close()
    });

    this.overlayRef.attach(new TemplatePortal(template, this.viewContainerRef, {$implicit: data, data1}));

    this.sub = fromEvent<MouseEvent>(document, 'click')
      .pipe(
        filter(event => {
          if (closeOnItemClick) {
            this.closeContext();
          } else {
            const clickTarget = event.target as HTMLElement;
            return !!this.overlayRef && !this.overlayRef.overlayElement.contains(clickTarget);
          }
        }), take(1)).subscribe(() => this.closeContext());
  }

  closeContext(): void {
    this.sub !== undefined && this.sub.unsubscribe();
    if (this.overlayRef) {
      this.overlayRef.dispose();
      this.overlayRef = null;
    }
  }

}
